// extracted by mini-css-extract-plugin
export default {"Modal":"AJKKtIw8G7WzfKjmLU4r","Modal__Content":"Q7ybSl228irpsHxpSrSA","Modal__Body":"DuXhfUB67FHE_CLg5Pv5","Button":"ws_30RU4ZukFATDrs7ao","ImageBox":"hYrE3YxtDswhP7ADWjXw"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"Modal\":\"AJKKtIw8G7WzfKjmLU4r\",\"Modal__Content\":\"Q7ybSl228irpsHxpSrSA\",\"Modal__Body\":\"DuXhfUB67FHE_CLg5Pv5\",\"Button\":\"ws_30RU4ZukFATDrs7ao\",\"ImageBox\":\"hYrE3YxtDswhP7ADWjXw\"}";
        // 1778765598734
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  